export const getShouldDisplayLoadingIndicator = state => state.app.LoadingIndicator.isLoading;